import { type LocalizationTextDirection } from './localizationTypes';

/** Searchable language list for the picker. Deduped and sorted at module load. */
const RAW_LOCALIZATION_LANGUAGES = [
  'Arabic',
  'Bengali',
  'Chinese (Simplified)',
  'Chinese (Traditional)',
  'Czech',
  'Danish',
  'Dutch',
  'English',
  'Finnish',
  'French',
  'German',
  'Greek',
  'Hebrew',
  'Hindi',
  'Indonesian',
  'Italian',
  'Japanese',
  'Korean',
  'Norwegian',
  'Persian',
  'Polish',
  'Portuguese',
  'Portuguese (Brazil)',
  'Romanian',
  'Russian',
  'Spanish',
  'Spanish (Latin America)',
  'Swedish',
  'Thai',
  'Turkish',
  'Ukrainian',
  'Urdu',
  'Vietnamese',
] as const;

/** Base language names that render right-to-left. Matched case-insensitively against the prefix. */
const RTL_LANGUAGE_PREFIXES = ['arabic', 'hebrew', 'persian', 'urdu'];

const uniqueLanguages = (languages: readonly string[]): string[] => {
  const seen = new Set<string>();

  return languages.filter((language) => {
    const key = language.trim().toLowerCase();

    if (!key || seen.has(key)) {
      return false;
    }

    seen.add(key);

    return true;
  });
};

export const LOCALIZATION_LANGUAGE_OPTIONS = uniqueLanguages(RAW_LOCALIZATION_LANGUAGES).sort((a, b) =>
  a.localeCompare(b),
);

export const filterLocalizationLanguages = (query: string): string[] => {
  const normalizedQuery = query.trim().toLowerCase();

  if (!normalizedQuery) {
    return LOCALIZATION_LANGUAGE_OPTIONS;
  }

  return LOCALIZATION_LANGUAGE_OPTIONS.filter((language) => language.toLowerCase().includes(normalizedQuery));
};

export const getLocalizationTextDirection = (language: string): LocalizationTextDirection => {
  const normalized = language.trim().toLowerCase();

  return RTL_LANGUAGE_PREFIXES.some((prefix) => normalized.startsWith(prefix)) ? 'rtl' : 'ltr';
};
